module.exports = __webpack_public_path__ + "img/Day-text.3c429f85.jpg";